module.exports = __webpack_public_path__ + "static/process_exporting4_2-3dd07fe9bcc7d84d85fc240eda9cb16b.png";